import useProtoMethod from "./useProtoMethod";
import {
  AdminListAllAdvisorsRequest,
  AdminListAllAdvisorsResponse,
  CreateAdvisorRequest,
  CreateAdvisorResponse,
  GenerateAdvisorContactsRequest,
  GenerateAdvisorContactsResponse,
  ImpersonationRequest,
  ImpersonationResponse,
  ListAllFamiliesRequest,
  ListAllFamiliesResponse,
  ListAuditRecordsRequest,
  ListAuditRecordsResponse,
  UpdateUserRolesRequest,
  UpdateUserRolesResponse,
  GetAllActiveFamilyPlanUtilizationRequest,
  GetAllActiveFamilyPlanUtilizationResponse,
  CreateAdvisorAnnotationResponse,
  CreateAdvisorAnnotationRequest,
  ListAdvisorAnnotationsResponse,
  ListAdvisorAnnotationsRequest,
  UpdateAdvisorAnnotationResponse,
  UpdateAdvisorAnnotationRequest,
} from "protogen/admin_service_pb";

const useListAllFamilies = () => {
  return useProtoMethod<ListAllFamiliesRequest, ListAllFamiliesResponse>(
    "ListAllFamilies",
    ListAllFamiliesResponse,
  );
};

const useListAuditRecords = () => {
  return useProtoMethod<ListAuditRecordsRequest, ListAuditRecordsResponse>(
    "ListAuditRecords",
    ListAuditRecordsResponse,
  );
};

const useCreateAdvisor = (callback?: (r: CreateAdvisorResponse) => void) => {
  return useProtoMethod<CreateAdvisorRequest, CreateAdvisorResponse>(
    "CreateAdvisor",
    CreateAdvisorResponse,
    { callback },
  );
};

const useUpdateRoles = (callback?: (r: UpdateUserRolesResponse) => void) => {
  return useProtoMethod<UpdateUserRolesRequest, UpdateUserRolesResponse>(
    "UpdateUserRoles",
    UpdateUserRolesResponse,
    { callback },
  );
};

const useAdminListAllAdvisors = (
  callback?: (r: AdminListAllAdvisorsResponse) => void,
) => {
  return useProtoMethod<
    AdminListAllAdvisorsRequest,
    AdminListAllAdvisorsResponse
  >("AdminListAllAdvisors", AdminListAllAdvisorsResponse, { callback });
};

const useGenerateAdvisorContacts = (
  callback?: (r: GenerateAdvisorContactsResponse) => void,
) => {
  return useProtoMethod<
    GenerateAdvisorContactsRequest,
    GenerateAdvisorContactsResponse
  >("GenerateAdvisorContacts", GenerateAdvisorContactsResponse, { callback });
};

const useImpersonation = (callback?: (r: ImpersonationResponse) => void) => {
  return useProtoMethod<ImpersonationRequest, ImpersonationResponse>(
    "Impersonation",
    ImpersonationResponse,
    { callback },
  );
};

const useAllActiveFamilyPlanUtilization = (
  callback?: (r: GetAllActiveFamilyPlanUtilizationResponse) => void,
) => {
  return useProtoMethod<
    GetAllActiveFamilyPlanUtilizationRequest,
    GetAllActiveFamilyPlanUtilizationResponse
  >(
    "GetAllActiveFamilyPlanUtilization",
    GetAllActiveFamilyPlanUtilizationResponse,
    { callback },
  );
};

const useCreateAdvisorAnnotation = (
  callback?: (r: CreateAdvisorAnnotationResponse) => void,
) => {
  return useProtoMethod<
    CreateAdvisorAnnotationRequest,
    CreateAdvisorAnnotationResponse
  >("CreateAdvisorAnnotation", CreateAdvisorAnnotationResponse, { callback });
};

const useListAdvisorAnnotations = (
  callback?: (r: ListAdvisorAnnotationsResponse) => void,
) => {
  return useProtoMethod<
    ListAdvisorAnnotationsRequest,
    ListAdvisorAnnotationsResponse
  >("ListAdvisorAnnotations", ListAdvisorAnnotationsResponse, { callback });
};

const useUpdateAdvisorAnnotation = (
  callback?: (r: UpdateAdvisorAnnotationResponse) => void,
) => {
  return useProtoMethod<
    UpdateAdvisorAnnotationRequest,
    UpdateAdvisorAnnotationResponse
  >("UpdateAdvisorAnnotation", UpdateAdvisorAnnotationResponse, { callback });
};
export {
  useListAllFamilies,
  useListAuditRecords,
  useAdminListAllAdvisors,
  useCreateAdvisor,
  useUpdateRoles,
  useGenerateAdvisorContacts,
  useImpersonation,
  useAllActiveFamilyPlanUtilization,
  useCreateAdvisorAnnotation,
  useListAdvisorAnnotations,
  useUpdateAdvisorAnnotation,
};
